export default __webpack_public_path__ + "static/media/37.fab656f2.jpg";